import React, { useState } from "react";
import "./Faq.css";

const faqData = [
  {
    question: "Quels services propose votre agence digitale à Lomé ?",
    answer:
      "Nous sommes spécialisés dans la conception de sites web professionnels, le développement d’applications mobiles (Android et iOS) et la création d’outils de gestion de stock et de gestion interne adaptés aux entreprises locales et internationales.",
  },
  {
    question: "Travaillez-vous uniquement avec des entreprises au Togo ?",
    answer:
      "Non. Bien que notre agence soit basée à Lomé au Togo, nous travaillons avec des clients partout en Afrique et à l’international grâce au travail à distance et aux outils collaboratifs.",
  },
  {
    question: "Combien de temps faut-il pour créer un site web ?",
    answer:
      "La durée dépend de la complexité du projet. Un site vitrine peut être livré en 1 à 2 semaines, tandis qu’un site plus complexe ou une application web peut prendre plusieurs semaines.",
  },
  {
    question: "Développez-vous des applications mobiles Android et iOS ?",
    answer:
      "Oui. Nous développons des applications mobiles performantes pour Android et iOS, adaptées aux besoins des entreprises, startups et organisations.",
  },
  {
    question: "Proposez-vous des solutions de gestion de stock sur mesure ?",
    answer:
      "Oui. Nous concevons des outils de gestion de stock personnalisés pour les commerces, pharmacies, entrepôts et entreprises, afin de mieux suivre les produits, les ventes et les approvisionnements.",
  },
  {
    question: "Est-ce que vos solutions sont adaptées aux réalités locales du Togo ?",
    answer:
      "Absolument. Nos solutions tiennent compte des réalités locales : connexion internet, méthodes de paiement, langue, et besoins spécifiques des entreprises togolaises.",
  },
  {
    question: "Quel est le coût de vos services ?",
    answer:
      "Les tarifs varient selon le type de projet et les fonctionnalités demandées. Nous proposons des solutions flexibles adaptées aux PME, startups et grandes entreprises.",
  },
  {
    question: "Assurez-vous la maintenance et le support après livraison ?",
    answer:
      "Oui. Nous proposons des services de maintenance, de mise à jour et d’assistance technique pour garantir le bon fonctionnement de vos solutions dans le temps.",
  },
  {
    question: "Puis-je demander des modifications après la livraison du projet ?",
    answer:
      "Oui. Nous prévoyons toujours une phase de retouches après livraison. Des évolutions supplémentaires peuvent également être ajoutées selon vos besoins.",
  },
  {
    question: "Comment puis-je démarrer un projet avec votre agence ?",
    answer:
      "Il suffit de nous contacter via notre formulaire, WhatsApp ou téléphone. Nous discuterons de votre projet, de vos objectifs et vous proposerons une solution adaptée.",
  },
];


export default function Faq() {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleToggle = (index) => {
    setActiveIndex((current) => (current === index ? null : index));
  };

  return (
    <section className="faq-section-fqt">
      <div className="faq-wrapper-fqt">
        {/* Top text bloc */}
        <div className="faq-top-fqt">
          <div className="faq-title-block-fqt">
            <h2 className="faq-title-fqt">
              Foires aux questions
              <br />
            </h2>
          </div>

          <div className="faq-contact-block-fqt">
            <p className="faq-contact-text-fqt">
             Si vous n’êtes pas satisfait des réponses,
              <br />
              contactez nous.
            </p>
            
          </div>
        </div>

        {/* FAQ list */}
        <div className="faq-list-fqt">
          {faqData.map((item, index) => {
            const isActive = index === activeIndex;
            return (
              <div
                key={item.question}
                className={`faq-item-fqt ${
                  isActive ? "faq-item-active-fqt" : ""
                }`}
              >
                <button
                  type="button"
                  className="faq-question-row-fqt"
                  onClick={() => handleToggle(index)}
                >
                  <span className="faq-question-text-fqt">
                    {item.question}
                  </span>
                  <span className="faq-icon-fqt">
                    {isActive ? "✕" : "+"}
                  </span>
                </button>

                {isActive && (
                  <div className="faq-answer-fqt">
                    <p>{item.answer}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
